// client/src/routes/_auth.tsx — the pathless auth layout (04 §9.2, §6.8) · AUTH-004.
//
// Every SCR-AUTH-* screen renders inside `AuthLayout` (`features/auth`, D-3940): the brand
// backdrop, the scene beside the card from `lg`, the full logo, the card and the footer links.
// Which of them a signed-in user may still open is decided per screen, not here — `/login`
// bounces an authenticated visitor to the app, `/mfa/enroll` must NOT, because a signed-in
// user opting in to MFA from SCR-SET-002 arrives there with a session.

import { Outlet, createFileRoute } from '@tanstack/react-router';

import { AuthLayout } from '@/features/auth/AuthLayout';

export const Route = createFileRoute('/_auth')({
  component: AuthRouteComponent,
});

function AuthRouteComponent() {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
}
